import React, {useRef, useState} from 'react'
import {makeStyles} from '@material-ui/styles';
import PollService from "services/PollService";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import {AppBar, IconButton, Paper, TextField, Toolbar, Typography} from "@material-ui/core";
import Tr from "translations/Translations";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import DoubleButton from "components/popup/components/DoubleButton";
import Loading from "components/Loading";
import PropTypes from "prop-types";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import TypographyWithIcon from "components/TypographyWithIcon";
import PollNpsSwitch from "components/popup/poll/PollNpsSwitch";

const useStyle = makeStyles(theme => ({
    root: {
        bottom: 100,
        right: 0,
        zIndex: theme.zIndex.appBar - 1,
        position: "fixed",
        maxWidth: 740
    },
    grid: {
        '&>*:first-child': {
            width: "100%"
        },
        '&>*:last-child': {
            width: "100%",
            marginBottom: theme.spacing(2)
        }
    },
    question: {
        padding: theme.spacing(2),
        textAlign: "center"
    },
    openQuestion: {
        width: 700,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
}))

function FeedbackContentOpen(
    {
        setOpen,
        poll,
        pollType,
        apiVersion
    }) {
    const classes = useStyle();
    const openQuestionRef = useRef();
    const [score, setScore] = useState();
    const [error, setError] = useState(false);


    const sendPool = (close) => {
        const rating = {
            pollType: pollType,
            objectType: "eZamawiajacy",
            objectId: apiVersion,
            score: close? null : score,
            answer: (close || openQuestionRef.current.value === '') ? null : openQuestionRef.current.value
        }

        PollService.savePollRating(rating);
        setOpen(false);
    }


    const handleClose = () => {
        sendPool(true);
        setOpen(false);
    }
    const handleSend = () => {
        if (score === undefined) {
            setError(true);
            return;
        }
        sendPool();
    }

    const scoreChange = (e, rate) => {
        setScore(rate);
        setError(false)
    }

    return (
        <div className={classes.root}>
            <Paper>
                {!poll ? <Loading/> :
                    <GridBlock direction="column" alignItems='center' className={classes.grid}>
                        <AppBar position="static">
                            <Toolbar variant="dense">
                                <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClose}>
                                    <NavigateNextIcon/>
                                </IconButton>
                                <Typography variant="h6" color="inherit">
                                    {poll.title}
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <BoldTypography className={classes.question}>{poll.question}</BoldTypography>

                        <PollNpsSwitch scoreChange={scoreChange} score={score} />

                        {!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{Tr('feedback_missing_rating')}</TypographyWithIcon>}

                        {!!poll.openQuestion &&
                            <TextField
                                inputRef={openQuestionRef}
                                className={classes.openQuestion}
                                label={poll.openQuestion}
                                fullWidth
                                multiline
                                maxRows={5}
                            />
                        }
                        <DoubleButton
                            justify="space-around"
                            labelFirst={Tr("close")}
                            onClickFirst={handleClose}
                            labelSecond={Tr("send")}
                            onClickSecond={handleSend}
                        />
                    </GridBlock>
                }
            </Paper>
        </div>
    )
}

FeedbackContentOpen.propTypes = {
    setOpen: PropTypes.func.isRequired,
    apiVersion: PropTypes.number,
    poll: PropTypes.shape({
        title: PropTypes.string.isRequired,
        question: PropTypes.string.isRequired,
        openQuestion: PropTypes.string
    }).isRequired,
    pollType: PropTypes.string.isRequired
}

export default FeedbackContentOpen;
